// extracted by mini-css-extract-plugin
module.exports = {"container":"TransportPermitsContainer_container__2n0Nl","header":"TransportPermitsContainer_header__TVbPF","title":"TransportPermitsContainer_title__1Q-W1"};